import React, { useState } from "react";
import { 
  Box, 
  Typography, 
  Accordion, 
  AccordionSummary, 
  AccordionDetails,
  Container,
  styled 
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const faqData = [
  {
    question: "Ardventure Nedir?",
    answer: "Ardventure, yasal düzenlemeler ışığında güçlü, yenilikçi ve sürdürülebilir bir girişimcilik ekosistemi oluşturmayı hedefleyen bir kitle fonlama platformudur. Girişimciler ile yatırımcıları güvenli bir ortamda buluşturarak, projelerin hayata geçmesine olanak sağlar."
  },
  {
    question: "Nasıl Yatırım Yapabilirim?",
    answer: "Ardventure'da yatırım yapmak için öncelikle üye olmanız ve E-Devlet doğrulaması yapmanız gerekir. Ardından Takasbank güvencesinde yatırım hesabınızı oluşturarak, minimum 500 TL'den başlayan tutarlarla dilediğiniz projelere yatırım yapabilirsiniz."
  },
  {
    question: "Yatırımlarım Güvende mi?",
    answer: "Tüm yatırımlarınız Takasbank güvencesi altındadır. Platform üzerinden yapılan tüm işlemler SPK düzenlemelerine uygun şekilde gerçekleştirilir ve düzenli denetimlerden geçer. Modern şifreleme teknikleri ve güvenlik önlemleriyle verileriniz koruma altındadır."
  },
  {
    question: "Nasıl Girişimci Olabilirim?",
    answer: "Girişimci olmak için platformumuza üye olduktan sonra, projenizle ilgili gerekli belgeleri ve iş planınızı sisteme yükleyebilirsiniz. Başvurunuz değerlendirildikten sonra, projeniz onaylanırsa kampanyanızı başlatabilir ve yatırımcılarla buluşabilirsiniz."
  },
  {
    question: "Fonlar Nasıl Yönetiliyor?",
    answer: "Yatırımcılardan toplanan fonlar, kampanya süresince Takasbank'ta bloke edilir. Kampanya başarılı olursa, fonlar girişimciye aktarılır. Başarısız olan kampanyalarda ise yatırımcılara otomatik olarak iade edilir. Tüm süreç şeffaf ve güvenli bir şekilde yönetilir."
  }
];

const FAQContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(8, 4),
  borderRadius: theme.spacing(2),
  maxWidth: 800,
  margin: '0 auto',
}));

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  borderRadius: `${theme.spacing(1)} !important`,
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
  '&:before': {
    display: 'none',
  },
  '&.Mui-expanded': {
    margin: `${theme.spacing(2)}px 0`,
  },
}));

const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  padding: theme.spacing(2, 3),
  '& .MuiAccordionSummary-content': {
    margin: `${theme.spacing(1)}px 0`,
  },
  '&.Mui-expanded': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    borderRadius: `${theme.spacing(1)}px ${theme.spacing(1)}px 0 0`,
    '& .MuiSvgIcon-root': {
      color: theme.palette.primary.contrastText,
    },
  },
}));

const StyledAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  padding: theme.spacing(3),
  borderTop: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
}));

const FAQSection = () => {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <FAQContainer>
        <Typography 
          variant="h4" 
          textAlign="center" 
          fontWeight="bold" 
          color="primary" 
          gutterBottom
          sx={{ mb: 6 }}
        >
          Sıkça Sorulan Sorular
        </Typography>

        {faqData.map((item, index) => (
          <StyledAccordion
            key={index}
            expanded={expanded === `panel${index}`}
            onChange={handleChange(`panel${index}`)}
          >
            <StyledAccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`panel${index}d-content`}
              id={`panel${index}d-header`}
            >
              <Typography variant="h6" fontWeight="500">
                {item.question}
              </Typography>
            </StyledAccordionSummary>
            <StyledAccordionDetails>
              <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
                {item.answer}
              </Typography>
            </StyledAccordionDetails>
          </StyledAccordion>
        ))}
      </FAQContainer>
    </Container>
  );
};

export default FAQSection;
